import React, { useEffect, useRef, useState } from "react";
import "./scrollReveal.css";

/**
 * Reusable zero-dependency scroll animation wrapper using IntersectionObserver
 */
const ScrollReveal = ({ children, className = "", delayClass = "", threshold = 0.15 }) => {
  const [isVisible, setVisible] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Triggers transition both when scrolling down into view and up into view
          setVisible(entry.isIntersecting);
        });
      },
      { threshold }
    );

    const currentRef = domRef.current;
    if (currentRef) observer.observe(currentRef);

    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, []);

  return (
    <div
      className={`reveal-section ${isVisible ? "is-visible" : ""} ${delayClass} ${className}`}
      ref={domRef}
    >
      {children}
    </div>
  );
};

export default ScrollReveal;